import styled from 'styled-components';
import { IMAGES } from './images';
import { useEffect } from 'react';

function ImageViewer() {
  // 이 페이지에서만 body의 min-width를 0으로 설정
  useEffect(() => {
    // 기존 min-width 값을 저장
    const originalMinWidth = document.body.style.minWidth;

    // min-width를 0으로 설정
    document.body.style.minWidth = '0';

    // 컴포넌트 언마운트 시 원래 값으로 복원
    return () => {
      document.body.style.minWidth = originalMinWidth;
    };
  }, []);

  return (
    <PageContainer>
      <ImageColumn>
        {IMAGES.map((image) => (
          <ImageWrapper key={image.id}>
            <Image src={image.url} alt={image.name} />
          </ImageWrapper>
        ))}
      </ImageColumn>
    </PageContainer>
  );
}

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  min-height: 100vh;
  flex: 1;
  overflow: auto;
  background-color: #6a6a6a;
  padding: 82px 20px 82px;

  @media (max-width: 767px) {
    padding: 24px 12px 24px;
  }
`;

const ImageColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 42px;
  max-width: 1080px;

  @media (max-width: 767px) {
    width: 100%;
    gap: 24px;
  }
`;

const ImageWrapper = styled.div``;

const Image = styled.img`
  width: 100%;
  height: auto;

  user-select: none;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;

export default ImageViewer;
